import React, { useEffect, useState } from 'react';
import '../assets/dashboard.css';
import Toast from '../components/Toast';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../components/Loader';
import Sweetalert from "sweetalert2";

const Dashboard = () => {
  const navigate = useNavigate();
  const [selectedDuration, setSelectedDuration] = useState('');
  const [autoMsg, setAutoMsg] = useState('');
  const [username, setUsername] = useState('');
  const [pendingOrders, setPendingOrders] = useState(0);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [infoLoading, setInfoLoading] = useState(true);
  const [markPaidOn, setMarkPaidOn] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = window.sessionStorage.getItem("usrtk");
    setInfoLoading(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/users/setmarktime`, 
      {
        method: "POST",
        body: JSON.stringify({time: parseInt(selectedDuration)}),
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setInfoLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message});
      }
      Toast.fire({icon: "success", title: "You have successfully set auto paid time to " + selectedDuration + "!"});
    })
    .catch((err) => {
      setInfoLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })
  };

  //Update auto message text
  const updateMessage = (e) => {
    e.preventDefault();
    const token = window.sessionStorage.getItem("usrtk");
    setInfoLoading(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/users/setautomessage`, 
      {
        method: "POST",
        body: JSON.stringify({message: autoMsg}),
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setInfoLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message});
      }
      Toast.fire({icon: "success", title: "You have successfully update the auto message text"});
    })
    .catch((err) => {
      setInfoLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })
  };

  //Change auto mark status
  const changeMarkPaidStatus = () => {
    const token = window.sessionStorage.getItem("usrtk");

    Sweetalert.fire({
      icon: "info",
      title: "Turn " + ((!markPaidOn) ? "ON" : "OFF") + " auto mark?",
      text: "This will turn " + ((!markPaidOn) ? "ON" : "OFF") + " your auto mark paid status.",
      position: "top-right",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, I am sure",
      width: "250px"
    })
    .then(res => {
      if (res.isConfirmed) {
        setInfoLoading(true);
          fetch(`${process.env.REACT_APP_SERVER_URL}/users/setautomark`, 
            {
              method: "POST",
              body: JSON.stringify({autoMark: !markPaidOn}),
              headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
              }
            }
          )
          .then(r => r.json())
          .then(res => {
            setInfoLoading(false);
            if (res.type === "error") {
              return Toast.fire({icon: "error", title: res.message});
            }
            const newStatus = (!markPaidOn) ? "ON" : "OFF";
            setMarkPaidOn(!markPaidOn);
            Toast.fire({icon: "success", title: "You have successfully turned " + newStatus + " auto mark paid"});
          })
          .catch((err) => {
            setInfoLoading(false);
            Toast.fire({icon: "error", title: "Server error"});
          })
      }
    })
  }

  useEffect(() => {
    const token = window.sessionStorage.getItem("usrtk");
    if (!token) {
      Toast.fire({icon: "error", title: "You need to be logged in"})
      .then(() => navigate("/login"));
    } else {
      //Get orders pending payment
      fetch(`${process.env.REACT_APP_SERVER_URL}/users/pendingorders`, 
        {
          headers: {
            "authorization": `Bearer ${token}`
          }
        })
      .then(r => r.json())
      .then(res => {
        setOrdersLoading(false);
        if (res.type === "error") {
          Toast.fire({icon: "error", title: res.message})
          .then(() => navigate('/login'));
        }
        console.log(res)
        setPendingOrders(res.count);
      })
      .catch((err) => {
        setOrdersLoading(false);
        Toast.fire({icon: "error", title: "Server error"});
      })

      
      //Get user info
      fetch(`${process.env.REACT_APP_SERVER_URL}/users/info`, 
        {
          headers: {
            "authorization": `Bearer ${token}`
          }
        })
      .then(r => r.json())
      .then(res => {
        setInfoLoading(false);
        if (res.type === "error") {
          Toast.fire({icon: "error", title: res.message})
          .then(() => navigate('/login'));
        }
        setMarkPaidOn(res.autoMark);
        setSelectedDuration(res.markTime + " min");
        setAutoMsg(res.autoMsg);
        setUsername(res.username);
      })
      .catch((err) => {
        setInfoLoading(false);
        Toast.fire({icon: "error", title: "Server error"});
      })
    }


  }, [navigate])

  const logout = () => {
    window.sessionStorage.removeItem("usrtk");
        Toast.fire({icon: "success", title: "Logged out"})
        .then(() => navigate('/login'));
  }

  return (
    <div className="dashboard-container">
      {
        infoLoading && <Loader content={""} />
      }
      <p style={{textAlign: "right"}}>
        <button onClick={logout}>Logout</button>
      </p>
      <h1>Welcome back, {username?.toUpperCase()}!</h1>

      <form onSubmit={handleSubmit} className="form-section">
        <label htmlFor="dropdown">Select auto mark paid duration:</label>
        <div>
          <select
            id="dropdown"
            value={selectedDuration}
            onChange={(e) => setSelectedDuration(e.target.value)}
          >
            <option value="">-- Choose an option --</option>
            <option value="2 min">2 min</option>
            <option value="3 min">3 min</option>
            <option value="4 min">4 min</option>
            <option value="5 min">5 min</option>
            <option value="9 min">10 min</option>
          </select>

          <button type="submit">Update Duration</button>
        </div>
      </form>

      <form className="form-section" onSubmit={updateMessage}>
        <label htmlFor="dropdown">Auto message text:</label>
          <textarea 
          rows={7} 
          maxLength={500} 
          value={autoMsg} 
          onChange={(e) => setAutoMsg(e.target.value)}
          ></textarea>
          <button type="submit">Update message</button>
      </form>


      <div className="toggle-section">
        <label className="switch">
          <input
            type="checkbox"
            checked={markPaidOn}
            onChange={changeMarkPaidStatus}
          />
          <span className="slider"></span>
        </label>
        <span className="switch-label">Auto mark paid status: {(markPaidOn) ? "ON" : "OFF"}</span>
      </div>

        <div className="summary-box">
          <p>Orders Pending Payment: </p>
          <h2>{ordersLoading? "loading..." : pendingOrders}</h2>
        </div>
        <p style={{padding: "20px 0px"}}>

            <Link to="/btcprice" >BTC Manual pricer &gt;&gt;</Link>
        </p>
        <div className="flex">
          <p style={{marginTop: "20px", textAlign: "center"}}>
            <Link to="/orders" >Pay orders &gt;&gt;</Link>
          </p>
          <p style={{marginTop: "20px", textAlign: "center"}}>
            <Link to="/setadcontrol" >Ads Control Setting &gt;&gt;</Link>
          </p>
          
        </div>
    </div>
  );
};

export default Dashboard;
